/*
 * @Author: Json Chen
 * @Date: 2021-07-06 14:59:47
 * @LastEditTime: 2021-07-08 12:52:22
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/request/salesChannel/setting/cookieSetting.ts
 */
import { get, post } from '@/src/tools/server';

export const getCookieSetting = (salesChannelUuid, params) => {
  console.log('salesChannelUuid, params: ', salesChannelUuid, params);
  return get<any>(
    `/portal/salesChannel/${salesChannelUuid}/setting/cookie`,
    params,
  );
};
export const resetCookieSetting = (salesChannelUuid) => {
  return get<any>(
    `/portal/salesChannel/${salesChannelUuid}/setting/cookie/reset`,
    {},
  );
};

export const setCookieSetting = (data, params = {}) => {
  return post<any>(`/portal/salesChannel/setting/cookie`, data, params);
};

export const copyCookieSetting = (salesChannelUuid, data) => {
  return post<any>(
    `/portal/setting/salesChannel/cookieSetting/${salesChannelUuid}/copy`,
    data,
    {},
  );
};
